import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CpfCnpjMaskDirective } from './directives/cpf-cnpj-mask.directive';
import { BrlCurrencyMaskDirective } from './directives/currency-mask.directive';
import { BrlCurrencyMaskPipe } from './directives/currency-mask.pipe';
import { ContainerMaskDirective } from './directives/container-mask.directive';
import { TelefoneMaskDirective } from './directives/telefone-mask.directive';
import { ExpandTruncateDirective } from './directives/expand-truncate.directive';
import { UsdCurrencyMaskPipe } from './directives/usd-currency-mask.pipe';
import { UsdCurrencyMaskDirective } from './directives/usd-currency-mask.directive';
import { PlacaVeiculoMaskDirective } from './directives/vehicle-plate-directive';
import { CampoAdicionalMaskDirective } from './directives/campo-adicional.directive';

@NgModule({
  declarations: [
    CpfCnpjMaskDirective,
    BrlCurrencyMaskDirective,   
    BrlCurrencyMaskPipe,
    ContainerMaskDirective,
    TelefoneMaskDirective,
    ExpandTruncateDirective,
    UsdCurrencyMaskDirective,
    UsdCurrencyMaskPipe,
    PlacaVeiculoMaskDirective,
    CampoAdicionalMaskDirective
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    CpfCnpjMaskDirective,
    BrlCurrencyMaskDirective,
    BrlCurrencyMaskPipe,
    ContainerMaskDirective,
    TelefoneMaskDirective,
    ExpandTruncateDirective,
    UsdCurrencyMaskDirective,
    UsdCurrencyMaskPipe,
    PlacaVeiculoMaskDirective,
    CampoAdicionalMaskDirective
  ]
})
export class SharedModule { }
